import { useEffect, useState } from 'react'
import { supabase } from '../../supabaseClient'
import {
  widgetCardStyle,
  labelStyle,
  valueStyle,
  footerStyle,
} from '../styles/widgetStyles'

function RiqInteractionsWidget() {
  const [count, setCount] = useState(0)
  const [hover, setHover] = useState(false)

  useEffect(() => {
    const fetchCount = async () => {
      const { data, error } = await supabase
        .from('riq_metrics')
        .select('total_riq_interactions')
        .single()
      if (!error && data) setCount(data.total_riq_interactions)
    }

    fetchCount()
  }, [])

  return (
    <div
      style={widgetCardStyle(hover)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div style={labelStyle}>
        📊 Total Riq Interactions
      </div>
      <div style={valueStyle}>{count}</div>
      <div style={footerStyle}>Total number of interactions with Riq since launch</div>
    </div>
  )
}

export default RiqInteractionsWidget
